// ======================================================================
// File Name       : ItemAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import { DEFAULT_DATE_SHORT_FORMAT_SERVER, MODE, SELECT_TARGET_DATA, STRUCTURE_TYPE } from '../constants';
import { CONTENT_DRILL_TYPE, CONTENT_TYPE } from '../constants/ContentConstant';
import { ITEM_IMAGE_TYPE } from '../constants/InitialImageConstants';
import { CHOSEN_THUMBNAIL_CONTENT, START_CONDITION_TYPE_FOR_ITEM } from '../constants/ItemConstant';
import * as ModalIds from '../constants/ModalIds';
import { USER_ATTRIBUTE_TYPE } from '../constants/UserAttributeConstants';
import * as itemActionCreators from './actionCreators/item';
import * as reportActionCreators from './actionCreators/report';
import * as containerActions from './ContainerAction';
import * as contentAction from './content/ContentAction';
import * as content from './httpRequests/content';
import * as document from './httpRequests/document';
import * as itemRequests from './httpRequests/item';
import * as thumbnail from './httpRequests/thumbnail';
import * as modalActions from './ModalAction';
import * as reportActions from './ReportAction';
import * as userAttributeActions from './UserAttributeAction';

export function updateItem({
  itemName,
  description,
  publicStatus,
  limitPublicPeriod,
  publicPeriodFrom,
  publicPeriodTo,
  endConditionTypeForItem,
  progressRatioForItemEnd,
  achievementRate,
  reportDeadline,
  reportReturnPlanDate,
  imageUploadFile,
  imageFileSelectType,
  dataUrl,
  // sprint_20230522_tma START
  startConditionTypeForItem,
  progressRatioForItemStart,
  // sprint_20230522_tma END
}) {
  return (dispatch) => {
    dispatch(
      reportActions.updateReport({
        reportDeadline,
        reportReturnPlanDate,
      }),
    );

    dispatch(
      itemActionCreators.updateItem({
        itemName,
        description,
        publicStatus,
        limitPublicPeriod,
        // #7388 START
        publicPeriodFrom: publicPeriodFrom ? moment(publicPeriodFrom).format(DEFAULT_DATE_SHORT_FORMAT_SERVER) : '',
        publicPeriodTo: publicPeriodTo ? moment(publicPeriodTo).format(DEFAULT_DATE_SHORT_FORMAT_SERVER) : '',
        // #7388 END
        endConditionTypeForItem,
        progressRatioForItemEnd: endConditionTypeForItem && achievementRate && progressRatioForItemEnd ? progressRatioForItemEnd : 0,
        achievementRate,
        imageUploadFile,
        imageFileSelectType,
        dataUrl,
        // sprint_20230522_tma START
        startConditionTypeForItem,
        progressRatioForItemStart: startConditionTypeForItem && progressRatioForItemStart ? progressRatioForItemStart: 0,
        // sprint_20230522_tma END
      }),
    );
  };
}

export function deleteItem(itemSecernId) {
  return (dispatch, getState) =>
    itemRequests
      .postItemEdit({
        editType: MODE.DELETE_MODE,
        itemInfo: {
          itemSecernId,
        },
      })
      .then(() => {
        dispatch(containerActions.deleteItemStructure(itemSecernId));
      });
}

export function saveItem() {
  return async (dispatch, getState) => {
    const {
      editMode,
      edittingItem: {
        itemSecernId,
        itemName,
        description,
        publicStatus,
        publicPeriodFrom,
        publicPeriodTo,
        endConditionTypeForItem,
        progressRatioForItemEnd,
        achievementRate,
        parentBoxSecernId,
        contentInfo,
        isItemReport,
        imageUploadFile,
        imageFileSelectType,
        dataUrl,
        limitPublicPeriod,
        // sprint_20230522_tma START
        startConditionTypeForItem,
        progressRatioForItemStart,
        // sprint_20230522_tma END
      },
    } = getState().item;
    const { editingReport: { reportDeadline, reportReturnPlanDate } } = getState().report;
    const { editingUserAtribute } = getState().userAttribute;
    const { structures, selectedItemSecernIdList } = getState().container;
    const receivedItemSecernId = (await itemRequests.postItemEdit({
      editType: editMode,
      itemInfo: {
        itemSecernId,
        itemName,
        description,
        publicStatus,
        publicPeriodFrom: publicPeriodFrom || '',
        publicPeriodTo: publicPeriodTo || '',
        endConditionTypeForItem,
        progressRatioForItemEnd,
        achievementRate,
        parentBoxSecernId: editMode === MODE.NEW_MODE ? parentBoxSecernId : null,
        contentInfo: editMode === MODE.NEW_MODE ? contentInfo : null,
        // sprint_20230522_tma START
        startConditionTypeForItem,
        progressRatioForItemStart,
        itemListForItemStart: startConditionTypeForItem !== START_CONDITION_TYPE_FOR_ITEM.NO_CONDITION ? selectedItemSecernIdList : [],
        // sprint_20230522_tma END
      },
    })).itemSecernId;

    let thumbnailUpload = imageUploadFile;
    if (imageUploadFile && imageUploadFile[0]) {
      thumbnailUpload = imageUploadFile[0];
    }
    const uploadThumnail = {
      thumbnailTargetType: 2,
      thumbnailTargetSecernId: receivedItemSecernId,
      imageFileSelectType,
      imageFileUpload: thumbnailUpload,
    };
    await dispatch(userAttributeActions.saveUserAttribute(USER_ATTRIBUTE_TYPE.ITEM, receivedItemSecernId, editMode));
    isItemReport && (await dispatch(reportActions.saveReport(itemName, receivedItemSecernId, editMode)));
    if (imageFileSelectType && imageFileSelectType == CHOSEN_THUMBNAIL_CONTENT.MANUAL && thumbnailUpload) {
      await thumbnail.editThumnail(uploadThumnail);
    }
    if (editMode == MODE.EDIT_MODE && imageFileSelectType == CHOSEN_THUMBNAIL_CONTENT.DEFAULT) {
      const uploadThumnailModeEdit = {
        thumbnailTargetType: 2,
        thumbnailTargetSecernId: receivedItemSecernId,
        imageFileSelectType: CHOSEN_THUMBNAIL_CONTENT.DEFAULT,
      };
      await thumbnail.editThumnail(uploadThumnailModeEdit);
    }
    dispatch(containerActions.editItemStructure(parentBoxSecernId, receivedItemSecernId));
    dispatch(modalActions.hideModal());
  };
}

export function searchContent(searchInfo) {
  return (dispatch) => {
    const { contentType, contentSecernId, contentName, remark, startPosition, excludeQuestion } = searchInfo;

    dispatch(
      contentAction.searchContent({
        contentSecernIds: contentSecernId,
        contentType,
        contentName,
        remark,
        startPosition,
        excludeQuestion,
      }),
    );
  };
}

export function fetchItemList(param) {
  return dispatch =>
    itemRequests
      .postItemGetList({
        searchInfo: {
          ...param,
        },
        selectTargetData: SELECT_TARGET_DATA.DATA,
      })
      .then((apiRes) => {
        dispatch(itemActionCreators.receiveItemList(apiRes));
      });
}

export function doFinishContentSelection(contentInfo) {
  return (dispatch) => {
    dispatch(itemActionCreators.receiveLinkingContent(contentInfo));
    dispatch(userAttributeActions.initUserAttributeEditing());
    dispatch(modalActions.openModal(ModalIds.CONTENT_LINKING_REGISTER_EDIT_DETAIL_SETTING));
  };
}

export function initDataForContentLinkingRegisterDialog(parentBoxSecernId) {
  return (dispatch) => {
    dispatch(itemActionCreators.initDataForRegisterContentLinkingDialog({ parentBoxSecernId }));
    dispatch(modalActions.openModal(ModalIds.CONTENT_LINKING_REGISTER));
    dispatch(reportActions.initDataForReportRegisterDialog());
    dispatch(userAttributeActions.initUserAttributeEditing());
  };
}

export function initDataForEditDetailConfirmContentLinkingDialog(itemSecernId, contentType) {
  return (dispatch) => {
    dispatch(modalActions.openModal(ModalIds.CONTENT_LINKING_DETAIL));
    const requests = [];
    requests.push(dispatch(fetchItemList({ itemList: [itemSecernId] })));
    contentType === CONTENT_TYPE.DRILL &&
      requests.push(
        dispatch(
          reportActions.fetchReport({
            searchInfo: {
              reportList: [itemSecernId],
            },
            selectTargetData: SELECT_TARGET_DATA.DATA,
          }),
        ).then(({ recordNum }) => recordNum > 0),
      );
    requests.push(dispatch(userAttributeActions.initUserAttributeEditing(USER_ATTRIBUTE_TYPE.ITEM, itemSecernId)));

    Promise.all(requests).then(([, isItemReport = false]) => {
      dispatch(containerActions.initDataForItemTreeDialog(itemSecernId, STRUCTURE_TYPE.ITEM, false)); // sprint_20230522_tma
      dispatch(itemActionCreators.initDataForDetailEditConfirmDialog(itemSecernId, isItemReport));
      dispatch(reportActionCreators.initDataForDetailEditConfirmDialog(itemSecernId));
    });
  };
}

export function changeData(data) {
  return itemActionCreators.changeData(data);
}

export function getDefaultThumbnail(contentType) {
  return async (dispatch, getState) => {
    const {
      edittingItem: {
        contentInfo,
      },
    } = getState().item;
    const { contentSecernId, drillTypeForItem } = contentInfo;
    contentType = parseInt(contentType, 10);
    let getDefaultFunc = null;
    let receiveFunc = itemActionCreators.getThumbnailDefault;
    let param = null;
    let isDispatch = true;
    switch (contentType) {
      case CONTENT_TYPE.DRILL:
        getDefaultFunc = getDrillDefaultThumbnail;
        param = contentSecernId;
        break;
      case CONTENT_TYPE.DOCUMENT:
        getDefaultFunc = getDocumentDefaultThumbnail;
        param = contentSecernId;
        receiveFunc = itemActionCreators.getDocumentThumbnailDefault;
        break;
      case CONTENT_TYPE.VIDEO:
        getDefaultFunc = getVideoDefaultThumbnail;
        param = contentSecernId;
        receiveFunc = itemActionCreators.getVideoThumbnailDefault;
        break;
      case CONTENT_TYPE.LINK: {
        const itemType = ITEM_IMAGE_TYPE.LINK;
        const searchInfo = {
          imageTypeList: [itemType],
        };
        getDefaultFunc = thumbnail.defaultThumbnail;
        isDispatch = false;
        param = {
          searchInfo,
        };
        break;
      }
      default:
        break;
    }
    const thumbnailDefault = isDispatch ?
    await dispatch(getDefaultFunc(param)) : await getDefaultFunc(param);
    return dispatch(receiveFunc(thumbnailDefault));
  };
}

function getDrillDefaultThumbnail(contentSecernId) {
  return async (dispatch, getState) => {
    const drillSearchInfo = {
      searchInfo: {
        contentList: [contentSecernId],
      },
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    const drillInfo = await content.getContentList(drillSearchInfo);
    if (drillInfo && drillInfo.contentList && drillInfo.contentList.length) {
      let drillTypeForItem = drillInfo.contentList[0].drillTypeForItem;
      let itemType = '';
      drillTypeForItem = parseInt(drillTypeForItem, 10);
      switch (drillTypeForItem) {
        case CONTENT_DRILL_TYPE.DRILL_MODE:
          itemType = ITEM_IMAGE_TYPE.DRILL;
          break;
        case CONTENT_DRILL_TYPE.TEST_MODE:
          itemType = ITEM_IMAGE_TYPE.TEST;
          break;
        case CONTENT_DRILL_TYPE.CORRECTION_MODE:
          itemType = ITEM_IMAGE_TYPE.REPORT;
          break;
        case CONTENT_DRILL_TYPE.ADAPTIVE_MODE:
          itemType = ITEM_IMAGE_TYPE.ADAPTIVE;
          break;
        default:
          itemType = ITEM_IMAGE_TYPE.DRILL;
      }
      const searchInfo = {
        imageTypeList: [itemType],
      };
      const thumbnailDefault = await thumbnail.defaultThumbnail({ searchInfo });
      return thumbnailDefault;
    }
    return {};
  };
}

function getVideoDefaultThumbnail(contentSecernId) {
  return async (dispatch, getState) => {
    const videoSearchInfo = {
      searchInfo: {
        contentSecernIdList: [contentSecernId],
      },
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    const videoInfo = await content.getVideoList(videoSearchInfo);
    if (videoInfo && videoInfo.contentList && videoInfo.contentList.length) {
      const thumbnailDefault = videoInfo.contentList[0];
      return thumbnailDefault;
    }
    return {};
  };
}

function getDocumentDefaultThumbnail(contentSecernId) {
  return async (dispatch, getState) => {
    const documentSearchInfo = {
      searchInfo: {
        contentSecernIdList: [contentSecernId],
      },
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    const documentInfo = await document.getDocumentDetail(documentSearchInfo);
    if (documentInfo &&
        documentInfo.documentContentList &&
        documentInfo.documentContentList.length) {
      const thumbnailDefault = documentInfo.documentContentList[0];
      return thumbnailDefault;
    }
    return {};
  };
}

export function saveDetailSettingState(name, value) {
  return itemActionCreators.saveDetailSettingState(name, value);
}